<div class="common-page">
  <div class="page-container">
    <div class="page-thumbnail">
      <img src="assets/images/illu_401_unauthorized.png" alt="">
    </div>
    <div class="page-titles text-center">
      <h2>{{'general.accessDenied' | translate}}</h2>
      <p>{{'general.accessDeniedMessage' | translate}}</p>

      <a mat-raised-button color='primary' [routerLink]="['/']">
        {{'general.goToHomepage' | translate}}
      </a>
    </div>
  </div>
</div>